import axios from 'axios';
import {
    BASE_API_URL,
    TG_WIDGET_JWT,
    TG_WIDGET_ACCESS_TOKEN,
    TG_WIDGET_MEMBER_ID,
    TG_WIDGET_BRANDING,
    TG_WIDGET_X_THEME
} from '../config/keys';

import { authenticateAccessToken } from './authenticate';

class BaseRequest {
    httpService: any;

    constructor () {
        this.httpService = axios.create({
            baseURL: BASE_API_URL
        });

        this.httpService.interceptors.request.use((config: any): any => {
            const memberID = config.memberID || localStorage.getItem(TG_WIDGET_MEMBER_ID);
            const xTheme = localStorage.getItem(TG_WIDGET_X_THEME);

            config.headers['x-member-key'] = Number(memberID);
            config.headers['x-widget'] = 'review-submission';
            config.headers['x-theme'] = xTheme;

            return config;
        });

        this.httpService.interceptors.response.use(
            (response:any) => {
                return Promise.resolve(response);
            },
            (error:any) => {
                if (error.response) {
                    const errors = (error.response.data || {}).errors || [];
                    error.response.customError = errors.length ? errors[0] : 'An error occurred';
                    return Promise.reject(error.response);
                } else {
                    return Promise.reject(error);
                }
            }
        );
    }

    get (path: string, params?: any) {
        return this.httpService.get(path, params);
    }

    patch (path: string, payload?: any) {

        return this.httpService.request({
            method: 'PATCH',
            url: path,
            responseType: 'json',
            data: payload || {}
        });
    }

    put (path: string, payload?: any) {

        return this.httpService.request({
            method: 'PUT',
            url: path,
            responseType: 'json',
            data: payload || {}
        });
    }

    post (path: string, payload?: any) {
        return this.httpService.request({
            method: 'POST',
            url: path,
            responseType: 'json',
            data: payload || {}
        });
    }

    delete (path: string, payload?: any) {
        return this.httpService.request({
            method: 'DELETE',
            url: path,
            responseType: 'json',
            data: payload || {}
        });
    }

    async all (requests: any) {
        return axios.all(requests);
    }
}

class SecureRequest extends BaseRequest {

    constructor() {
        super();

        this.httpService.interceptors.request.use((config: any): any => {
            const accessToken = localStorage.getItem(TG_WIDGET_ACCESS_TOKEN);
            const jwt = localStorage.getItem(TG_WIDGET_JWT);

            if (!accessToken.length) {
                return Promise.reject('SecureRequest: No accessToken');
            }

            config.headers['x-access-token'] = accessToken;
            config.headers['x-jwt'] = jwt || '';
            return config;
        });

        this.httpService.interceptors.response.use(null, (error: any) => {
            const branding = localStorage.getItem(TG_WIDGET_BRANDING) ? JSON.parse(localStorage.getItem(TG_WIDGET_BRANDING)) : '';
            const { SiteName } = branding;

            if (error.config && error.status === 403) {
                return authenticateAccessToken(SiteName).then(jwt => {

                    if (!jwt) {
                        return Promise.reject(new Error('Failed to get JWT'));
                    }

                    error.config.headers['x-jwt'] = jwt;
                    return axios.request(error.config);
                });
            }
            
            return Promise.reject(error);
        });
    }
}

export const http = new BaseRequest();
export const secureHttp = new SecureRequest();
